"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQuestionnaireBuilders = generateQuestionnaireBuilders;
const fieldTypes_1 = require("../../../types/carrierQuestionnaire/fieldTypes");
const FieldBuilder_1 = require("./FieldBuilder");
const FieldGroupBuilder_1 = __importDefault(require("./FieldGroupBuilder"));
const QuestionnaireBuilder_1 = __importDefault(require("./QuestionnaireBuilder"));
const SectionBuilder_1 = __importDefault(require("./SectionBuilder"));
const SectionGroupBuilder_1 = __importDefault(require("./SectionGroupBuilder"));
const SubsectionBuilder_1 = __importDefault(require("./SubsectionBuilder"));
function generateQuestionnaireBuilders(seedProviders) {
    return {
        aQuestionnaire() {
            return new QuestionnaireBuilder_1.default(seedProviders);
        },
        aSectionGroup() {
            return new SectionGroupBuilder_1.default(seedProviders);
        },
        aRepeatableSectionGroup({ nodeId }) {
            return new SectionGroupBuilder_1.default(seedProviders).makeRepeatable({ nodeId });
        },
        aSection() {
            return new SectionBuilder_1.default(seedProviders);
        },
        aStep() {
            return new SectionBuilder_1.default(seedProviders);
        },
        aSubsection() {
            return new SubsectionBuilder_1.default(seedProviders);
        },
        aFieldGroup() {
            return new FieldGroupBuilder_1.default(seedProviders);
        },
        aRepeatableFieldGroup({ nodeId }) {
            return new FieldGroupBuilder_1.default(seedProviders).makeRepeatable({ nodeId });
        },
        aTextField() {
            return new FieldBuilder_1.TextFieldBuilder(seedProviders);
        },
        aDateField() {
            return new FieldBuilder_1.DateFieldBuilder(seedProviders);
        },
        aYearMonthField() {
            return new FieldBuilder_1.YearMonthFieldBuilder(seedProviders);
        },
        // TODO @questionnaireBuilder Should this be type AgreeField?
        aConsentField() {
            return new FieldBuilder_1.ConsentFieldBuilder(seedProviders);
        },
        aNumberField() {
            return new FieldBuilder_1.NumberFieldBuilder(seedProviders);
        },
        aPhoneField() {
            return new FieldBuilder_1.PhoneFieldBuilder(seedProviders);
        },
        aMoneyField() {
            return new FieldBuilder_1.MoneyFieldBuilder(seedProviders);
        },
        aDropdownField() {
            return new FieldBuilder_1.OptionFieldBuilder(seedProviders);
        },
        aRadioField() {
            return new FieldBuilder_1.OptionFieldBuilder(seedProviders).withType(fieldTypes_1.FieldTypes.radio);
        },
        aCheckboxGroupField() {
            return new FieldBuilder_1.OptionFieldBuilder(seedProviders).withType(fieldTypes_1.FieldTypes.checkboxGroup);
        },
        aDynamicDropdownField(dynamicOptions) {
            return new FieldBuilder_1.DynamicOptionFieldBuilder(seedProviders, dynamicOptions).withType(fieldTypes_1.FieldTypes.dropdown);
        },
        anInformationField() {
            return new FieldBuilder_1.InformationFieldBuilder(seedProviders);
        },
        aButtonField() {
            return new FieldBuilder_1.ButtonFieldBuilder(seedProviders);
        },
        aSignatureField(participantRole) {
            return new FieldBuilder_1.SignatureFieldBuilder(seedProviders, participantRole);
        },
    };
}
